import CRUDService from './geral/CRUDService';
import { http } from '../config/Constantes';

export default class PisoSalarialService extends CRUDService {
  constructor() {
    super('pisos-salariais');
  }

  contarContratosImpactados(params) {
    // O endpoint é /pisos-salariais/contratos-impactados?sindicatoId=...&empresaId=...&valor=...
    // O objeto 'params' do axios formata isso corretamente na URL.
    return http.get(`/${this.serviceName}/contratos-impactados`, { params });
  }

  listarSindicatos() {
    // O endpoint para sindicatos é /sindicatos, não tem relação com /pisos-salariais
    return http.get(`/${this.serviceName}/sindicatos`);
  }
}
